// test1977
(1977 && 0);
